import { convertToUpperCase } from "../utils/Formatter";
import "../styles/components/AddNewButton.css";

const AddNewButton = ({ category, onClick }) => (
  <button className="add-new-button" onClick={onClick}>
    + ADD NEW {convertToUpperCase(category)}
  </button>
);

export default AddNewButton;
